import React, { useReducer } from "react";
import { Modal, Popup, Icon } from "semantic-ui-react";
import UpdatePatientelle from "../../Patientelle/UpdatePatientelle/UpdatePatientelle";
import {
  initialState,
  reducer,
  ACTION,
} from "../../../Reducer/InitialStateReducer";

function Note(props) {
  const [state, dispatch] = useReducer(reducer, initialState);

  //   const { ID, userInformation, getOneUser AuthState} = props;

  return (
    <>
      <Popup
        content="Identification du patient"
        trigger={
          <Icon
            circular
            inverted
            color="teal"
            floated="left"
            onClick={() => dispatch({ type: ACTION.OPEN, size: "large" })}
            name="address card"
            size="large"
            className="centerIcon_And_Float_Right"
          />
        }
      />
      <Modal
        size={state.size}
        open={state.open}
        onClose={() => dispatch({ type: ACTION.CLOSE })}
      >
        <Modal.Header>Identification du patient</Modal.Header>
        <Modal.Content>
          <UpdatePatientelle />
        </Modal.Content>
      </Modal>
    </>
  );
}

export default Note;
